module.exports = __webpack_public_path__ + "img/type_img04.77cb1e96.png";